import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { BillingProdiverListItem, BillingProviderListFilter } from '@/models/dictionary/billing-provider-list.model';

export default class GetBillingProviderListRequest extends ApiResourceMethod<BillingProdiverListItem[]> {
  public perform(filterList?: BillingProviderListFilter): Promise<BillingProdiverListItem[]> {
    const params = {
      filterList,
    };

    return this.performer.requestWithMapper(
      { params },
      (payload: BaseResponse<BillingProdiverListItem[]>) => {
        return payload.data;
      },
    );
  }
}
